import React, {Component} from 'react';

class HomeStaticBanner8 extends Component {
    getOrderedIconPath(index) {
        const iconPaths = [
            '/assets/img/cat-icon1.png',
            '/assets/img/cat-icon2.png',
            '/assets/img/cat-icon3.png',
            '/assets/img/cat-icon4.png',
        ];

        return iconPaths[index] || iconPaths[0];
    }

    getBanners() {
        return (Array.isArray(this.props.banner) ? this.props.banner : [])
            .filter((bannerItem) => bannerItem && bannerItem.image_path && bannerItem.image_path.trim() !== '');
    }

    getCardCopy(bannerItem, index) {
        const rawTitle = (bannerItem.image_title || '').trim();
        const rawLink = (bannerItem.link_url || '').trim();

        return {
            title: rawTitle || `Category ${index + 1}`,
            href: rawLink,
        };
    }

    renderIcon(index) {
        return <img src={this.getOrderedIconPath(index)} alt="" aria-hidden="true" />;
    }

    render() {
        const banners = this.getBanners().slice(0, 4);

        if (banners.length === 0) {
            return null;
        }

        return (
            <div className="container">
                <section className="ps-home-static-banner8" aria-label="Featured categories">
                    <div className="ps-home-category-banner">
                        <div className="ps-home-category-banner__content">
                            <h1 className="ps-home-category-banner__eyebrow">Welcome to Nature Way!</h1>
                            <h2 className="ps-home-category-banner__title" id="home-static-banner8-title">
                                <span className="ps-home-category-banner__titleLead">Where Tradition</span>{' '}
                                <span className="ps-home-category-banner__titleFor">Preserves</span>{' '}
                                <span className="ps-home-category-banner__titleTail">Nature&apos;s Goodness</span>
                            </h2>
                            <img className="ps-home-category-banner__divider" src="/assets/img/about/about-line.png" alt="" aria-hidden="true" />
                            <p className="ps-home-category-banner__subtitle">Shop By Category</p>
                        </div>
                    </div>
                    <div className="ps-home-static-banner8__grid">
                        {banners.map((bannerItem, index) => {
                            const copy = this.getCardCopy(bannerItem, index);
                            const cardContent = (
                                <>
                                    <div className="ps-home-static-banner8__media">
                                        <img
                                            className="ps-home-static-banner8__image"
                                            src={bannerItem.image_path}
                                            alt={copy.title}
                                            loading="lazy"
                                        />
                                    </div>
                                    <div className="ps-home-static-banner8__badge" aria-hidden="true">
                                        <span className="ps-home-static-banner8__badgeCircle">
                                            {this.renderIcon(index)}
                                        </span>
                                    </div>
                                    <div className="ps-home-static-banner8__body">
                                        <h3 className="ps-home-static-banner8__title">{copy.title}</h3>
                                    </div>
                                </>
                            );

                            return (
                                <article className="ps-home-static-banner8__card" key={`${copy.title}-${index}`}>
                                    {copy.href ? (
                                        <a
                                            className="ps-home-static-banner8__link"
                                            href={copy.href}
                                            target={/^https?:\/\//i.test(copy.href) ? '_blank' : undefined}
                                            rel={/^https?:\/\//i.test(copy.href) ? 'noreferrer noopener' : undefined}
                                        >
                                            {cardContent}
                                        </a>
                                    ) : (
                                        <div className="ps-home-static-banner8__link">
                                            {cardContent}
                                        </div>
                                    )}
                                </article>
                            );
                        })}
                    </div>
                </section>
            </div>
        );
    }
}

export default HomeStaticBanner8;
